import { store } from "@src/redux/store";

export const MY_PERMISSIONS_PATH = "/auth/my-permissions";

const REFRESH_DEBOUNCE_MS = 2000;

let refreshPromise: Promise<void> | null = null;
let lastRefreshAt = 0;

/** True for verifyRole-style forbidden messages (not business-rule 403s). */
export const isPermissionForbiddenMessage = (message?: string): boolean => {
  if (!message) return false;
  return (
    /insufficient permissions/i.test(message) ||
    /^forbidden:\s*insufficient permissions/i.test(message)
  );
};

/** Debounced refresh — safe to call from many parallel 403 responses. */
export const requestPermissionRefresh = (): void => {
  const now = Date.now();
  if (refreshPromise && now - lastRefreshAt < REFRESH_DEBOUNCE_MS) {
    return;
  }

  if (refreshPromise) {
    return;
  }

  refreshPromise = import("@src/redux/auth")
    .then(({ refreshUserPermissions }) =>
      store.dispatch(refreshUserPermissions()).unwrap()
    )
    .then(() => {
      lastRefreshAt = Date.now();
    })
    .catch(() => {
      // Ignore — list page already shows TableErrorState
    })
    .finally(() => {
      refreshPromise = null;
    });
};
